import React from 'react';
import classNames from 'classnames';
import Icon from '@/src/app/components/Icon/Icon';
import { IconName } from '@/src/app/components/Icon/types';

export type CheckboxProps = {
  isRadio?: boolean;
  label: string | React.JSX.Element;
  description?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  labelClassName?: string;
} & React.InputHTMLAttributes<HTMLInputElement>;

function Checkbox({
  id,
  value,
  name,
  disabled,
  isRadio,
  required,
  label,
  description,
  onChange,
  className,
  checked,
  labelClassName,
}: CheckboxProps) {
  let inputClasses = 'border-solid ';

  if (isRadio) {
    inputClasses += 'rounded-full bg-white peer-checked:bg-black peer-checked:shadow-[inset_0_0_0_5px_white]';
  } else {
    inputClasses += 'peer-checked:bg-black peer-checked:text-primary peer-checked:border-black';
  }
  return (
    <label
      htmlFor={id}
      className={classNames('relative flex items-start', { 'cursor-not-allowed': disabled }, className)}
    >
      <div className="flex h-5 items-center" data-testid={id}>
        <input
          id={id}
          aria-describedby={`${id}-description`}
          name={name}
          type={isRadio ? 'radio' : 'checkbox'}
          className="peer sr-only"
          disabled={disabled}
          value={value || 'true'}
          required={required}
          onChange={onChange}
          checked={checked}
        />
        <div
          className={classNames(
            'border border-gray-300',
            'bg-gray-300 w-6 h-6 text-transparent ring-offset-2',
            'peer-focus-visible:ring peer-focus:ring-black',
            'peer-disabled:bg-gray-100 peer-disabled:cursor-not-allowed',
            'flex items-center justify-center',
            'transition-colors duration-150 ease-in-out',
            inputClasses,
          )}
        >
          {!isRadio ? <Icon name={IconName.CHECK} className="text-lg! pointer-events-none block" /> : null}
        </div>
      </div>
      <div className="ml-3 text-sm">
        {label ? (
          <div className={classNames('label', { 'label--disabled': disabled }, labelClassName)}>{label}</div>
        ) : null}
        {description ? (
          <p id={`${id}-description`} className={classNames('text-sm', disabled ? 'text-gray-400' : 'text-gray-500')}>
            {description}
          </p>
        ) : null}
      </div>
    </label>
  );
}

export default Checkbox;
